"use client";

import { UpdateAvailableBanner } from "@/components/version-check/update-available-banner";
import { env } from "@/env.mjs";
import { authClient } from "@/lib/auth-client";
import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react";
import { ConvexReactClient } from "convex/react";
import type { ReactNode } from "react";
import { useMemo } from "react";
import { ChunkLoadRecovery } from "./chunk-load-recovery";

export function ConvexClientProvider({
  children,
  initialToken,
}: {
  children: ReactNode;
  initialToken?: string | null;
}) {
  const convex = useMemo(
    () =>
      new ConvexReactClient(env.NEXT_PUBLIC_CONVEX_URL, {
        expectAuth: !!initialToken,
      }),
    [initialToken],
  );

  return (
    <ConvexBetterAuthProvider
      client={convex}
      authClient={authClient}
      initialToken={initialToken}
    >
      <ChunkLoadRecovery />
      <UpdateAvailableBanner />
      {children}
    </ConvexBetterAuthProvider>
  );
}
